import { connect } from 'react-redux';

import Component from '../../components/js/modules/CustomLogger';
import { IStates } from '../CommonStateType';

// CustomLogger移行後
const mapStateToProps = (state: IStates, ownProps?: { isEnabledViewable?: boolean; isManualUpdate?: boolean }) => {
  return {
    // CustomLogger移行完了後にpageDataへ命名変更予定
    pageParam: {
      ...state.pageData.pageParam,
      status: state.userData.isLogin ? 'login' : 'logout'
    },
    isEnabledViewable: ownProps?.isEnabledViewable ?? false,
    isManualUpdate: ownProps?.isManualUpdate ?? false
  };
};

export default connect(mapStateToProps)(Component);
